import type { BasecampAssignment } from '@/types/basecamp';

/** Detect BC5 subtask rows from Reports API assignment payloads. */
export function isAssignmentSubtask(raw: {
  type?: string;
  parent?: { type?: string; id?: string | number; title?: string };
}): boolean {
  if (!raw) return false;
  if (raw.type === 'Kanban::Step') return true;
  if (raw.parent?.type === 'Todo') return true;
  return false;
}

export function normalizeAssignmentRecordingFields(
  raw: {
    type?: string;
    parent?: { type?: string; id?: string | number; title?: string };
    parent_title?: string;
  },
  existing?: Partial<BasecampAssignment>,
): Pick<BasecampAssignment, '_recording_type' | '_parent_todo_id' | '_parent_title'> {
  if (isAssignmentSubtask(raw)) {
    return {
      _recording_type: 'Kanban::Step',
      _parent_todo_id:
        raw.parent?.id != null
          ? String(raw.parent.id)
          : existing?._parent_todo_id,
      _parent_title: raw.parent?.title ?? raw.parent_title ?? existing?._parent_title,
    };
  }
  return {
    _recording_type: 'Todo',
    _parent_todo_id: undefined,
    _parent_title: raw.parent?.title ?? raw.parent_title ?? existing?._parent_title,
  };
}
